import { load } from "@shopify/theme-sections";
import isMobile from "is-mobile";
import { add, listen, qs } from "@fluorescent/dom";
import revive, { iddle } from "@/js/extra/revive";
import {hydrate} from "@/js/glow/events.js";

// Islands
const islands = {
  ...import.meta.glob('@/js/sections/*.js'),
  ...import.meta.glob('@/js/modules/*.js')
}

revive(islands)

async function loadLibraries() {
  await iddle()

  import('@/js/extra/load-libraries.js')
}

loadLibraries()

const loadSections = async () => {
  // Import sections
  const modules = {
    ...import.meta.glob('@/js/templates/*.js'),
    ...import.meta.glob('@/js/templates/**/*.js'),
  };

  const modulePromises = Object.values(modules).map(module => module());
  await Promise.all(modulePromises);
  load("*");
  hydrate({ SelectedProductSection: null });
};

// Call above function either immediately or bind on loaded event
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  loadSections();
} else {
  listen(document, "DOMContentLoaded", loadSections);
}

// eslint-disable-next-line no-prototype-builtins
if (!HTMLElement.prototype.hasOwnProperty("inert")) {
  import( /* @vite-ignore */ flu.chunks.polyfillInert);
}

if (isMobile({ tablet: true, featureDetect: true })) {
  const isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  if (isIosDevice) {
    add(document.body, "is-ios-device")
  } else {
    add(document.body, "is-mobile")
  }
}

window.addEventListener('scroll', () => {
  if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    document.body.classList.add('is-end-scroll')
  } else {
    document.body.classList.remove('is-end-scroll')
  }
})

// Note: we can't update the class where it's added (theme-setup.liquid) because it loads before window.Shopify.visualPreviewMode, preventing any logic checks from properly applying
window.addEventListener("load", function () {
  // Block animations within the visual preview mode only
  if (window.Shopify.visualPreviewMode) {
    document.documentElement.classList.remove("do-anim");
  }
});